export { default, default as TextInput } from './TextInput'
export * as TextInputStyles from './styles/TextInput.style'

export type { TextInputProps } from './TextInput.types'
export type { StyledTextInputProps } from './styles/TextInput.style.types'
export type { AutoCompleteTypes } from './AutoCompleteTypes.types'
